import get from 'lodash.get';

import { createLoadMoreMethod } from '../../../../../../../../../../../util/apollo';

/**
 * Accepts a source object and a `mappings` array and fetches records and
 * returns a normalized object that represents the available records for
 * for photo selection.
 *
 * For usage with PhotoSelectionOverlayModal.
 *
 * @param {Object} options - The options.
 * @param {Object} options.source - The source object to extract records from.
 * @param {Array<Object>} options.mappings - The tab mappings in the form of {id, label, path, [mapper], [loader]}.
 * @param {Function} [options.fetchMore] - Optional fetchMore function if there's a need to create loadMore methods.
 * @returns {Array<Object>} - The candidate photo groups.
 */
export const createPhotoSelectionCandidatePhotoGroups = ({
  source,
  mappings,
  fetchMore,
}) => {
  if (!source) {
    return [];
  }

  return mappings
    .map(({ id, label, path, offsetVariable, mapper = x => x, loader }) => {
      // Do not replace lodash.get here.
      const data = get(source, path, {});
      const loadMore =
        loader ||
        createLoadMoreMethod({
          source,
          recordsPath: path,
          offsetVariableLabel: offsetVariable ?? `${id}Offset`,
          fetchMore,
        });

      return {
        id,
        label,
        total: data.total,
        photos: (data.records || []).map(mapper),
        loadMore,
      };
    })
    .filter(group => group.photos.length > 0);
};
